import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/es";
import "dayjs/locale/en";
import { useAppSelector } from "../../../app/hooks";
import { selectLanguage } from "../../../slices/language";

interface DatePickerCustomProps {
  value: Dayjs | null;
  setValue: (value: Dayjs | null) => void;
}

const DatePickerCustom = ({ value, setValue }: DatePickerCustomProps) => {
  const language = useAppSelector(selectLanguage);

  React.useEffect(() => {
    dayjs.locale(language === "es" ? "es" : "en");
  }, [language]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={language}>
      <DatePicker
        value={value}
        onChange={(newValue) => setValue(newValue)}
        slotProps={{
          textField: { size: "small", fullWidth: true },
          openPickerButton: {
            size: "small",
          },
        }}
        format="DD/MM/YYYY"
      />
    </LocalizationProvider>
  );
};

export default DatePickerCustom;
